import Deffered from '@tgtg/core/async/Deffered';
import { type Hash } from 'history';
import { router } from 'src/core/Router';

import { CHANGE_PASSWORD_PATH } from '../../../core/paths/paths';

import changePasswordMatcher from './changePasswordMatcher';
const PLUGIN_NAME = 'CHANGE_PASSWORD';

function changePasswordPluginCreator(hash: Hash): () => Promise<unknown> {
  const params = changePasswordMatcher(hash);
  return function changePasswordPlugin(): Promise<unknown> {
    if (!params?.token) return Promise.reject();

    const dfd = new Deffered();
    const { token, email } = params;
    dfd.resolve({
      name: PLUGIN_NAME,
    });
    router.navigate(CHANGE_PASSWORD_PATH, {
      replace: true,
      state: { resetPasswordToken: token, userEmail: email },
    });

    return dfd.promise;
  };
}

export default changePasswordPluginCreator;
